import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { Anchor } from '@fttb/common';
import { isEmpty } from 'lodash';
import { withAnalyticsOnRender } from "../../../ConnectionStatusPage/hoc/withAnalyticsOnRender/withAnalyticsOnRender";
import { getAddressCheckModuleData } from "../../store/selectors";
import { ADDRESS_BLOCK_VIEW_STATUSES } from "../../store/blocks/addressVerification/constants";
import { handleRenderBlockWithAvailableStatuses } from "../../store/blocks/addressVerification/actions/analytics";
import { useInitAddressAndScrollTo } from "./hooks/useInitAddressAndScrollTo";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import styles from "./styles.pcss";
import { AddressInput, ButtonContainer, Container, PhoneInput } from "./components";
import { selectCurrentViewTexts } from "../../store/blocks/addressVerification/selectors";
import { initAddressAndRunVerification } from "../../store/blocks/addressVerification/actions/initAddressAndRunVerification";
var cx = classNames.bind(styles);
var _AddressVerificationBlock = function _AddressVerificationBlock(_ref) {
  var className = _ref.className,
    onMount = _ref.onMount;
  useInitAddressAndScrollTo(onMount);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Anchor, {
    anchorId: FttbBlocks.CHECK_ADDRESS,
    "data-t-id": "blocks-AddressVerificationBlock"
  }), /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "blocks-AddressVerificationBlock"
  }, /*#__PURE__*/React.createElement(AddressInput, null), /*#__PURE__*/React.createElement(PhoneInput, null), /*#__PURE__*/React.createElement(ButtonContainer, null))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: !isEmpty(selectCurrentViewTexts(state)),
    /* Параметр для хока withAnalyticsOnRender
       Позволяет отправлять аналитику при статусе !== checkAddress
     */
    deps: getAddressCheckModuleData(state).status === ADDRESS_BLOCK_VIEW_STATUSES.checkAddress
  };
};
var mapDispatchToProps = {
  onMount: initAddressAndRunVerification,
  onRender: handleRenderBlockWithAvailableStatuses
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var AddressVerificationBlock = compose(connector, defineBlock(FttbBlocks.ADDRESS_VERIFICATION), withRenderFlag, withAnalyticsOnRender)(_AddressVerificationBlock);